import styled from '@emotion/styled';

export const StyledLogo = styled.img`
  width: 180px;
  height: 180px;
  object-fit: contain;
  margin: ${({ theme }) => theme.getSpacing(1, 'px')};
`;
